/**
 * @desc 分页
 */
const URL = "/rantion-plat-data-flow";
import http, { updateResponse } from "@/http";
export function request(params: API.platDataFlow.platformReport.page.Params, options?: any) {
  return updateResponse(
    http(URL + `/platformReport/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
